{
  "title": "Summon Celestial",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "5th-level conjuration",
  "level": 5,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (a golden reliquary worth at least 500 gp)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You call forth a celestial spirit. It manifests in an angelic form in an unoccupied space that you can see within range. This corporeal form uses the Celestial Spirit stat block. When you cast the spell, choose Avenger or Defender. Your choice determines the creature’s attack in its stat block. The creature disappears when it drops to 0 hit points or when the spell ends.",
    "The creature is an ally to you and your companions. In combat, the creature shares your initiative count, but it takes its turn immediately after yours. It obeys your verbal commands (no action required by you). If you don’t issue any, it takes the Dodge action and uses its move to avoid danger.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th level or higher, use the higher level whenever the spell’s level appears in the stat block.",
    "Celestial Spirit",
    "Large celestial",
    "Armor Class: 11 + the level of the spell (natural armor) + 2 (Defender only)",
    "Hit Points: 40 + 10 for each spell level above 5th",
    "Speed: 30 ft., fly 40 ft.",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "16 (+3)",
    "14 (+2)",
    "16 (+3)",
    "10 (+0)",
    "14 (+2)",
    "16 (+3)",
    "Damage Resistances: radiant",
    "Condition Immunities: charmed, frightened",
    "Senses: darkvision 60 ft., passive Perception 10",
    "Languages: Celestial, understands the languages you speak",
    "Challenge: —",
    "Proficiency Bonus: equals your bonus",
    "Actions",
    "Multiattack. The celestial makes a number of attacks equal to half this spell’s level (rounded down).",
    "Radiant Bow (Avenger Only). Ranged Weapon Attack: your spell attack modifier to hit, reach 150/600 ft., one target. Hit: 2d6 + 2 + the spell’s level radiant damage.",
    "Radiant Mace (Defender Only). Melee Weapon Attack: your spell attack modifier to hit, reach 5 ft., one target. Hit: 1d10 + 3 + the spell’s level radiant damage, and the celestial can choose itself or another creature it can see within 10 feet of the target. The chosen creature gains 1d10 temporary hit points.",
    "Healing Touch (1/Day). The celestial touches another creature. The target magically regains hit points equal to 2d8 + the spell’s level."
  ],
  "spellLists": ["cleric", "paladin"]
}
